import MediaFrame from "@/components/feature/MediaFrame";
import Reveal from "@/components/feature/Reveal";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { clinic } from "@/mocks/clinic";
import type { TreatmentPageData } from "@/mocks/treatmentPages";

export default function TreatmentHero({ data }: { data: TreatmentPageData }) {
  return (
    <section className="relative overflow-hidden border-b border-background-300/70 bg-background-50 pb-16 pt-28 md:pb-20 md:pt-36 lg:pb-24 lg:pt-40">
      <div
        aria-hidden
        className="pointer-events-none absolute -right-24 top-24 h-72 w-72 rounded-full bg-secondary-100/50 blur-3xl"
      />

      <div className="u-container relative">
        {/* カテゴリ親ページ：HOME ＞ 現在のカテゴリ（実在しない TREATMENT 階層は使用しない） */}
        <Breadcrumb
          items={[
            { label: "HOME", href: "/", path: "/" },
            { label: data.jp, path: `/treatment/${data.slug}` },
          ]}
        />

        <div className="mt-10 grid grid-cols-1 gap-12 lg:mt-14 lg:grid-cols-[1.05fr_0.95fr] lg:items-center lg:gap-16">
          <div>
            <Reveal>
              <span className="en-eyebrow block text-[11px] text-secondary-700 md:text-[12px]">{data.en}</span>
              <span className="mt-5 block h-px w-12 bg-accent-500" />
              <h1 className="mt-7 font-heading text-[32px] leading-[1.5] tracking-[0.02em] text-foreground-950 md:text-[44px]">
                {data.jp}
              </h1>
              <p className="mt-7 whitespace-pre-line text-[14px] leading-[2.2] text-foreground-700 md:text-[15px]">
                {data.heroLead}
              </p>
            </Reveal>

            <Reveal delay={140}>
              <div className="mt-9 flex flex-wrap items-center gap-x-6 gap-y-3 text-[12px] text-foreground-600">
                <span className="flex items-center gap-2">
                  <i className="ri-map-pin-line text-accent-700" aria-hidden />
                  渋谷駅近く
                </span>
                <span className="hidden h-4 w-px bg-foreground-950/15 sm:block" />
                <span className="flex items-center gap-2">
                  <i className="ri-time-line text-accent-700" aria-hidden />
                  診療時間 {clinic.hours}
                </span>
              </div>
            </Reveal>
          </div>

          <Reveal delay={120}>
            <MediaFrame
              src={data.heroImage || undefined}
              srcMobile={data.heroImageMobile}
              alt={data.heroImageAlt}
              tone="greige"
              icon="ri-image-line"
              label="TREATMENT VISUAL"
              note={data.heroNote}
              objectPosition={data.heroObjectPosition}
              className={data.heroFrameClass ?? "h-[280px] w-full sm:h-[360px] lg:h-[440px]"}
            />
          </Reveal>
        </div>
      </div>
    </section>
  );
}